import { StyleSheet } from 'react-native';
import { PALETTE, MQ_TABLET, SEPARATOR_STROKE } from '../../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";
import ResponsiveDimensionValues from '../../common/responsive-dimension-values';
var windowWidth = ResponsiveDimensionValues.windowWidth;

export default MediaQueryStyleSheet.create({
  scene: {
    marginTop: 50
  }
});